import React, { useState } from "react";
import {
    Box,
    Grid,
    Typography,
Container,
    Paper,
    CircularProgress
} from "@mui/material";
/* Iconos React */
import "../../theme/Login/login.css"
import { FiAlertCircle } from 'react-icons/fi';
import { TbLock } from "react-icons/tb";
import { TbLockOpen } from "react-icons/tb";
import { useNavigate } from "react-router-dom";


import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { useAuth } from "../../hooks/UserContext";

import logo from "../../assets/logo/logoblanco.png";
import colegio from "../../assets/img/antilllen.png";

export const Login = () => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const { login } = useAuth();

    const handleSubmit = async (e) => {
    e.preventDefault();

    setEmailError("");
    setPasswordError("");
    setLoading(true);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
        await login(email, password);

        navigate("/admin/antilen");
    } catch (error) {
        console.error("Error en login:", error);

        if (error.response?.status === 401) {
            setPasswordError("Correo o contraseña incorrectos.");
        } else if (error.response?.data?.message) {
            setPasswordError(error.response.data.message);
        } else {
            setPasswordError("No fue posible iniciar sesión.");
        }
    } finally {
        setLoading(false);
    }
};
    return (
        <Box
            sx={{
                minHeight: "100vh",
                background: "#edf2f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                mt: 5
            }}
        >
            <Container maxWidth='lg'>
            <Paper
                elevation={10}
                sx={{
                    overflow: "hidden",
                    borderRadius: 5,
                    width: "100%",
                    maxWidth: 1400,
                }}
            >
                <Grid container>
                    {/* LADO IZQUIERDO */}
                    <Grid
                        size={{ xs: 12, sm: 7 }}
                        sx={{
                            position: "relative",
                            minHeight: 750,
                            backgroundImage: `linear-gradient(rgba(8,23,53,.75),rgba(8,23,53,.75)),url(${colegio})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            color: "#fff",
                            p: 6,
                            display: {
                                xs: "none",
                                md: "flex",
                            },
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        <Box>
                            <img
                                src={logo}
                                alt=""
                                style={{
                                    width: 220,
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography
                                variant="h3"
                                fontWeight="bold"
                                sx={{
                                    lineHeight: 1.1,
                                }}
                            >
                                Formamos alumnos
                            </Typography>
                            <Typography
                                variant="h3"
                                fontWeight="bold"
                                sx={{
                                    lineHeight: 1.1,
                                }}
                            >
                                para transformar
                            </Typography>
                            <Box
                                sx={{
                                    width: "100%",
                                    textAlign: "left",
                                    mb: 4
                                }}
                            >
                                <Typography
                                    variant="h3"
                                    fontWeight="bold"
                                    sx={{
                                        lineHeight: 1.1,
                                    }}
                                >
                                    El <strong style={{ color: "#06a3f8" }}>futuro</strong>
                                </Typography>

                                <Box
                                    sx={{

                                        width: 80,
                                        height: 4,
                                        bgcolor: "#06a3f8",
                                        borderRadius: "10px",
                                    }}
                                />
                            </Box>
                            <Box sx={{ mt: 1 }}>
                                <Typography
                                    mt={3}
                                    sx={{
                                        fontSize: 17,
                                        opacity: .9,
                                    }}
                                >
                                    Educación de excelencia basada en valores,

                                </Typography>
                                <Typography
                                    mt={3}
                                    sx={{
                                        fontSize: 17,
                                        opacity: .9,
                                    }}
                                >

                                    respeto y compromiso con la comunidad.
                                </Typography>
                            </Box>
                        </Box>

                        <Grid container spacing={4}>
                            <Grid size={4} sx={{ display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backdropFilter: "blur(8px)",
                                        transition: "all .3s ease",

                                        "&:hover": {
                                            backgroundColor: "rgba(255,255,255,0.25)",
                                            transform: "translateY(-4px)",
                                        },
                                    }}
                                >
                                    <SchoolOutlinedIcon sx={{ fontSize: 45 }} />
                                </Box>

                                <Typography mt={2}>
                                    Excelencia
                                </Typography>
                                <Typography >
                                    Académica
                                </Typography>
                            </Grid>

                            <Grid size={4} sx={{ display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backdropFilter: "blur(8px)",
                                        transition: "all .3s ease",

                                        "&:hover": {
                                            backgroundColor: "rgba(255,255,255,0.25)",
                                            transform: "translateY(-4px)",
                                        },
                                    }}
                                >
                                    <FavoriteBorderOutlinedIcon sx={{ fontSize: 45 }} />
                                </Box>

                                <Typography mt={2}>
                                    Formación
                                </Typography>
                                <Typography mt={2}>
                                    en Valores
                                </Typography>
                            </Grid>

                            <Grid size={4} sx={{ display: "flex", alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column' }}>
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backdropFilter: "blur(8px)",
                                        transition: "all .3s ease",

                                        "&:hover": {
                                            backgroundColor: "rgba(255,255,255,0.25)",
                                            transform: "translateY(-4px)",
                                        },
                                    }}
                                >
                                    <GroupsOutlinedIcon sx={{ fontSize: 42, color: "#fff" }} />
                                </Box>
                                <Typography mt={2}>
                                    Comunidad
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* LOGIN */}
                    <Grid
                        size={{ xs: 12, sm: 5 }}
                        sx={{
                           
                            display: "flex",
                            alignItems: "center",
                            justifyContent:'center',
                                   
                                    }}
                    >
                        <Box width="100%">
                            <Typography
                                variant="h3"
                                fontWeight="bold"
                                sx={{color:'#484a75'}}
                            >
                                Bienvenido
                            </Typography>

                            <Typography
                                color="text.secondary"
                                mb={5}
                                 sx={{color:'#585857', fontWeight:600, mb:2}}
                            >
                                Inicia sesión para continuar
                            </Typography>

                            <form
    className="formempresaingreso"
    onSubmit={handleSubmit}
>
                    
                    <div className="inputFormEmpresapaginaingreso">
                        <svg
                            style={{ fill: '#ffff' }}
                            height="20"
                            viewBox="0 0 32 32"
                            width="20"

                        >
                            <g id="Layer_3" data-name="Layer 3">
                                <path
                                    d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"
                                ></path>
                            </g>
                        </svg>
                        <input
                            required
                            id="email"
                            name="email"
                            autoComplete="email"
                            className="inputloginempresa"
                            placeholder="ingrese email"
                            style={emailError ? { borderColor: 'red' } : {}} />
                    </div>

                   
                    <div className="inputFormEmpresapaginaingreso" >
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                background: "transparent",
                                border: "0px",
                                padding: "0px",
                            }}
                        >
                            {showPassword ? (
                                <TbLockOpen style={{ fontSize: "1.5rem", color: "#ffff" }} />
                            ) : (
                                <TbLock style={{ fontSize: "1.5rem", color: "#ffff" }} />
                            )}
                        </button>
                        <input
                            required
                            name="password"
                            id="password"
                            autoComplete="current-password"
                            type={showPassword ? "text" : "password"}
                            className="inputloginempresa"
                            placeholder="Ingrese contraseña" />
                    </div>
                    <div className="contiene-error-mensaje" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', left: '0' }}>
                        {passwordError &&
                            <span className="errormessagelogin" style={{ color: '#ffff', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                                <FiAlertCircle className='icon-error' style={{ marginRight: '5px' }} />{passwordError}
                            </span>}
                    </div>
                    <div className="contiene-error-mensaje" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', left: '0' }}>
                        {emailError && (
                            <span className="errormessagelogin" style={{ color: '#ffff' }}>
                                <FiAlertCircle className='icon-error' />
                                {emailError}
                            </span>
                        )}
                    </div>
                    <div className="cotienenbutonloginempresa">
                        <button type='submit' className="buttoningresoempresasubmit"> {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Iniciar Sesión'}</button>
                    </div>


                </form>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            </Container>
        </Box>
    );
};